import { Item, sfAnd, sfEqual } from 'spring-filter-query-builder';
import { DimrStatusCode } from '../../api/dto';
import { escapeSfqbString } from '../sfqb';
import { sfLike } from './sfqb';

export const makeDimrVersionCodeFilter = (searchValue: string, onlyDrafts: boolean): string => {
    let query: Item = sfLike('versionCode', `${escapeSfqbString(searchValue, true)}*`, true);
    if (onlyDrafts) {
        query = sfAnd([query, sfEqual('status.code', escapeSfqbString(DimrStatusCode.DRAFT))]);
    }
    return query.toString();
};

export const makeDimrVersionByMasterIdFilter = (masterId: number): string => {
    let query: Item = sfEqual('dimrMasterId', masterId);
    return query.toString();
};
